var angular = require('angular');
var template = require('./template.pug');

 angular.module("app.directives").directive('paginator', function () {
  return {
    restrict: 'E',
    scope: {
      pages: "=",
      current: "=",
      range: "=",
      onChange: "&"
    },
    template: template,
    replace: true,
    link: function (scope, element, attrs) {
      scope.$watchGroup(["pages", "current", "range"], function(){
        scope.pagesArray = generatePagesArray(parseInt(scope.current), scope.pages, scope.range || 9 );
      })


      scope.nextPage = function(){
        scope.gotoPage(parseInt(scope.current) + 1)
      }

      scope.prevPage = function(){
        scope.gotoPage(parseInt(scope.current) - 1)
      }

      scope.gotoPage = function(number){
        if (scope.onChange()) {
          scope.onChange()(number, parseInt(scope.current));
        }
      }
    }
  }


});



// http://www.michaelbromley.co.uk/blog/108/paginate-almost-anything-in-angularjs

function generatePagesArray(currentPage, totalPages, paginationRange) {
  var pages = [];
  var halfWay = Math.ceil(paginationRange / 2);
  var position;

  if (currentPage <= halfWay) {
    position = 'start';
  } else if (totalPages - halfWay < currentPage) {
    position = 'end';
  } else {
    position = 'middle';
  }

  var ellipsesNeeded = paginationRange < totalPages;
  var i = 1;
  while (i <= totalPages && i <= paginationRange) {
    var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);
    if (!ellipsesNeeded) {
      pages.push(pageNumber);
      i++;
      continue;
    }
    var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
    var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
    if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
      pages.push('...');
    } else {
      pages.push(pageNumber);
    }
    i++;
  }
  return pages;
}

function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
  var halfWay = Math.ceil(paginationRange / 2);
  if (i === paginationRange) {
    return totalPages;
  } else if (i === 1) {
    return i;
  } else if (paginationRange < totalPages) {
    if (totalPages - halfWay < currentPage) {
      return totalPages - paginationRange + i;
    } else if (halfWay < currentPage) {
      return currentPage - halfWay + i;
    } else {
      return i;
    }
  } else {
    return i;
  }
}
